module.exports = __webpack_public_path__ + "media/hero.0416674f.webm";